// import redux and persist plugins
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer } from 'reduxjs-toolkit-persist';
import storage from 'reduxjs-toolkit-persist/lib/storage';
import sessionStorage from 'reduxjs-toolkit-persist/lib/storage/session';
import persistStore from 'reduxjs-toolkit-persist/es/persistStore';
import { FLUSH, PAUSE, PERSIST, PURGE, REGISTER, REHYDRATE } from 'reduxjs-toolkit-persist/es/constants';
import { encryptTransform } from 'redux-persist-transform-encrypt';
import { DeviceUUID } from 'device-uuid';

// import theme reducers
import settingsReducer from 'settings/settingsSlice';
import layoutReducer from 'layout/layoutSlice';
import langReducer from 'lang/langSlice';
import authReducer from 'auth/authSlice';
import menuReducer from 'layout/nav/main-menu/menuSlice';
import scrollspyReducer from 'components/scrollspy/scrollspySlice';
import dashboardReducer from 'features/dashboard/dashboardSlice';

// per i clienti
import contratti99Reducer from 'features/99/contratti/contrattiSlice';
import schede99Reducer from 'features/99/schedeTecniche/schedeSlice';
import tickets99Reducer from 'features/99/tickets/ticketsSlice';
import scadenze99Reducer from 'features/99/scadenze/scadenzeSlice';
import conversazioni99Reducer from 'features/99/conversazioni/conversazioniSlice';
import documenti99Reducer from 'features/99/documenti/documentiSlice';

// roba per i fornitori
import contratti80Reducer from 'features/80/contratti/contrattiSlice';
import rating80Reducer from 'features/80/rating/ratingSlice';

// Roba per gli agenti
import contratti98Reducer from 'features/98/contratti/contrattiSlice';
import schede98Reduceer from 'features/98/schedeTecniche/schedeSlice';
import scadenze98Reducer from 'features/98/scadenze/scadenzeSlice';
import documenti98Reducer from 'features/98/documenti/documentiSlice';

// Roba per il bi
import biReducer from 'features/bi/biSlice';

// ROba per i 65
import notaSpeseReducer from 'features/65/notaSpeseSlice';

// Roba per le requests
import requestsReducer from 'features/requests/requestsSlice';

// Roba per le labels
import labelsReducer from 'features/labels/labelsSlice';

// import persist key
import { REDUX_PERSIST_KEY, REDUX_AUTH_PERSIST_KEY } from 'config.js';

// Roba globale
import globalReducer from 'features/global/globalSlice';

const persistConfig = {
  key: REDUX_PERSIST_KEY,
  storage,
  whitelist: ['menu', 'settings', 'lang'],
};

const uuid = new DeviceUUID().get();

const authPersistConfig = {
  key: REDUX_AUTH_PERSIST_KEY,
  storage: sessionStorage,
  transforms: [
    encryptTransform({
      secretKey: uuid,
      onError(error) {
        console.log(error);
      },
    }),
  ],
};

const persistedReducer = persistReducer(
  persistConfig,
  combineReducers({
    settings: settingsReducer,
    layout: layoutReducer,
    lang: langReducer,
    auth: persistReducer(authPersistConfig, authReducer),
    menu: menuReducer,
    scrollspy: scrollspyReducer,
    dashboard: dashboardReducer,
    contratti99: contratti99Reducer,
    schede99: schede99Reducer,
    tickets99: tickets99Reducer,
    conversazioni99: conversazioni99Reducer,
    scadenze99: scadenze99Reducer,
    documenti99: documenti99Reducer,
    contratti80: contratti80Reducer,
    rating80: rating80Reducer,
    contratti98: contratti98Reducer,
    schede98: schede98Reduceer,
    scadenze98: scadenze98Reducer,
    documenti98: documenti98Reducer,
    bi: biReducer,
    global: globalReducer,
    notaSpese: notaSpeseReducer,
    requests: requestsReducer,
    labels: labelsReducer,
  })
);
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});
const persistedStore = persistStore(store);
export { store, persistedStore };
